import { css } from '@emotion/react'
import { fonts as customFonts } from '@conexasaude/hero-tokens'
import { generateCustomFonts } from '../utils/generateCustomFonts'

export const fonts = css`
  ${generateCustomFonts({ fonts: customFonts })}
`
